import { Descriptions } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getExamArchive } from "../../../api/archives.api";
import ExamDownloadHistoryModal from "../../../components/archive/exam/modals/ExamDownloadHistoryModal";
import Button from "../../../components/Button";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetExamArchive } from "../../../models/archives.model";
import { RootState } from "../../../store/rootReducer";

interface IMatch {
  examCode: string;
}

const ArchiveExamRead = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const examCode = Number(match.params.examCode);
  const history = useHistory();
  const location = useLocation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetExamArchive>();

  const [downloadHistoryVisible, setDownloadHistoryVisible] = useState(false);

  useEffect(() => {
    if (examCode) {
      execute(getExamArchive(examCode));
    }
  }, [examCode]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-archive-big.svg"
        parentMenu={t('common.menu.resources')}
        currentMenu={t('archive.exam.title2')}
      />

      <div className="comm-table__area rowType">
        <Descriptions
          bordered
          column={3}
          size="small"
          labelStyle={{ width: '16.6%' }}
          contentStyle={{ width: '16.6%' }}
        >
          <Descriptions.Item label={t('archive.exam.column4')}>
            {res?.data?.examName}
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.placeholder1')}>
            {getCommonCodeLabel('TE0001', res?.data?.examDiv || '', 'ko')}
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.column3')}>
            {res?.data?.examTypeName}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.text.year')}>
            {res?.data?.year}
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.column5')}>
            {res?.data?.testSeq}
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.column6')}>
            {moment(res?.data?.regDate || '').format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.column7')} span={3}>
            {
              res?.data?.examFiles
                ? res?.data?.examFiles.map(item => (
                  <a
                    className="download-link btn-text mr-2"
                    href={item.fileLocation}
                    download={item.originalName}
                  >
                    {item.originalName}
                  </a>
                ))
                : '-'
            }
          </Descriptions.Item>
        </Descriptions>

        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              text={t('common.button.list')}
              onClick={() => history.push(`/archive/exam${location.search}`)}
            />
          </div>
          <div className="comm-btn__area right">
            {
              auth?.hqYn === 'Y' && auth?.groupNo === 1000
                ? (
                  <Button
                    className="btn-basic pink-line"
                    text={t('archive.exam.button1')}
                    onClick={() => setDownloadHistoryVisible(true)}
                  />
                )
                : null
            }
          </div>
        </div>
      </div>

      <ExamDownloadHistoryModal
        visible={downloadHistoryVisible}
        setVisible={setDownloadHistoryVisible}
        examCode={examCode}
      />
    </div>
  );
}

export default ArchiveExamRead;
